<script lang="ts">
  import { xhr, toast } from "$app/utils"
  import Loading from "$app/components/Loading.svelte"
  import Honeybadger from "$app/utils/honeybadger"

  interface Props {
    progress: any
    type?: string
    operation?: string
    oncreate?: (data: ProgressType) => void
    onupdate?: (data: ProgressType) => void
    oncancel?: () => void
  }

  let {
    progress,
    type = "goal",
    operation = "update",
    oncreate,
    onupdate,
    oncancel
  }: Props = $props()

  let form = $state({ ...progress })
  let errors: any = $state({})
  let saving = $state(false)

  async function updateProgress(): Promise<any> {
    saving = true

    try {
      const resp = await xhr.put(
        `/plans/${progress.plan_id}/${type}_progress/${progress.id}`,
        {
          [`${type}_progress`]: { progress_text: form.progress_text }
        }
      )
      onupdate(resp.data)
    } catch (e) {
      toast("There was an error updating the goal progress", "error")
      if (e.response.data) {
        errors = e.response.data.errors
      } else {
        if (typeof Honeybadger.notify !== "undefined") {
          Honeybadger.notify(e)
        }
      }
    } finally {
      saving = false
    }
  }

  async function createProgress(): Promise<void> {
    saving = true

    try {
      const resp = await xhr.post(
        `/plans/${progress.plan_id}/${type}_progress`,
        {
          [`${type}_progress`]: {
            [`${type}_id`]: progress[`${type}_id`],
            progress_text: form.progress_text
          }
        }
      )

      oncreate(resp.data)
    } catch (e) {
      if (typeof Honeybadger.notify !== "undefined") {
        Honeybadger.notify(e)
      }
      toast("There was an error creating the progress", "error")
    } finally {
      saving = false
    }
  }
</script>

<div class="sm:flex w-full" data-name="progress-form">
  <div class="w-full">
    <textarea rows="2" bind:value={form.progress_text} class="input flex-auto"
    ></textarea>
    {errors.progress_text ? errors.progress_text : ""}
  </div>
  <div class="py-2 sm:py-0 flex sm:items-stretch">
    <Loading loading={saving} class="flex">
      <button
        class="btn bg-green-600 text-green-100 ml-2 px-4"
        data-name="save-progress"
        onclick={() => {
          if (operation === "update") {
            updateProgress()
          } else {
            createProgress()
          }
        }}
      >
        {operation === "update" ? "Update Progress" : "Add Progress"}
      </button>
    </Loading>

    <button
      disabled={saving}
      data-name="cancel-progress"
      class="btn secondary px-4 ml-2"
      type="button"
      onclick={() => oncancel()}
    >
      Cancel
    </button>
  </div>
</div>
